import { API_URL, DEBUG } from 'src/parameters'
import { Logout } from 'src/utils/logout'
import 'whatwg-fetch'

/**
 *
 * Initer data
 * @param  {[type]} query [description]
 * @return {[type]}        [description]
 */
export function graph<T>(query: any) {
  return new Promise<T>((resolve, reject) => {
    const headers = getHeaders()
    if (DEBUG === true) {
      // console.log(query)
    }

    window
      .fetch(`${API_URL}`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ query }),
      })
      .then(async response => {
        if (
          response.status === 422 ||
          response.status === 403 ||
          response.status === 404 ||
          response.status === 500
        ) {
          return reject(await response.json());
        }
        return response.json()
      })
      .then(result => {
        if (result.errors) {
          reject(result.errors)
        } else if (result && result.data) {
          resolve(result.data);
        }
      })
      .catch(err => {
        return reject(err)
      })
  })
}

export function getHeaders() {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: '',
    // Origin: window.location.origin,
  }
  if (localStorage.getItem('meCurrent') !== null) {
    const a: any = localStorage.getItem('meCurrent')

    // Fake connexion
    if (!a || !JSON.parse(a).user) {
      Logout.logout()
      return
    }

    const email = JSON.parse(a).user.email
    const token = JSON.parse(a).token
    const accountId = JSON.parse(a).account.id
    headers.Authorization = `oauth_token = ${token}, oauth_owner_key = ${email}, account_id = ${accountId}`
  }

  return headers
}

export function signS3URLGet(params: { key: string; name: string, bucket?: string }): Promise<any> {
  return new Promise((resolve, reject) => {
    const headers = getHeaders()

    window
      .fetch(`${API_URL}/s3/sign/get?key=${params.key}&name=${params.name}${params.bucket ? `&bucket=${params.bucket}` :''}`, {
        method: 'GET',
        headers,
      })
      .then(async response => {
        if (
          response.status === 422 ||
          response.status === 403 ||
          response.status === 404 ||
          response.status === 500
        ) {
          return reject(await response.json())
        }
        return response.json()
      })
      .then((result: any) => {
        resolve(result)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

export function signS3URLCloudfrontGetBulk(params: { urls: string[]; }): Promise<any> {
  return new Promise((resolve, reject) => {
    const headers = getHeaders()
    window
      .fetch(`${API_URL}/s3/sign-cloudfront/get/bulk`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          urls: params.urls,
        }),
      })
      .then(async response => {
        if (
          response.status === 422 ||
          response.status === 403 ||
          response.status === 404 ||
          response.status === 500
        ) {
          return reject(await response.json())
        }
        return response.json()
      })
      .then((result: any) => {
        resolve(result)
      })
      .catch(err => {
        return reject(err)
      })
  })
}



export function signS3URLPut(params: { objectName: string; contentType: string, acl?: string, bucket?: string }) {
  return new Promise((resolve, reject) => {
    const headers = getHeaders()
    window
      .fetch(`${API_URL}/s3/sign?objectName=${params.objectName}&contentType=${params.contentType}${params.bucket ? `&bucket=${params.bucket}` :''}${params.acl ? `&acl=${params.acl}` :''}`, {
        method: 'GET',
        headers,
      })
      .then(async response => {
        if (
          response.status === 422 ||
          response.status === 403 ||
          response.status === 404 ||
          response.status === 500
        ) {
          return reject(await response.json())
        }
        return response.json()
      })
      .then(result => {
        resolve(result)
      })
      .catch(err => {
        return reject(err)
      })
  })
}




// WEBPACK FOOTER //
// ./src/utils/graph/index.ts